/* Butter & Batch floating navigation, never cover the moving parade. */
(function(){
 'use strict';
 const parade=document.querySelector('#header-group .bb-parade');
 const header=document.querySelector('#header-group .bb-header');
 if(!parade||!header)return;
 let queued=false;
 function update(){
  queued=false;
  const gap=window.matchMedia('(max-width:900px)').matches?10:14;
  header.style.top=Math.max(gap,Math.ceil(parade.getBoundingClientRect().bottom+12))+'px';
 }
 function requestUpdate(){if(queued)return;queued=true;requestAnimationFrame(update);}
 update();
 window.addEventListener('scroll',requestUpdate,{passive:true});
 window.addEventListener('resize',requestUpdate,{passive:true});
 window.addEventListener('pageshow',requestUpdate);
})();
